/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Autocomplete, Box, Checkbox, CircularProgress, FormControl, FormControlLabel, FormGroup, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField, Tooltip, Typography } from "@mui/material";
import { showNotification } from "../../../../common/Notification/ToastifyNotification";
import { ArchitecturalCode, Discontinues, LifeExpectancy, PriceType, ProductStatus, ProductType, Responsibility } from "../../../../common/const";
import CreateDialog from "./CreateDialog";
import { Add } from "@mui/icons-material";
import ProductProvider from "./ProductProvider";
import { apiRequest } from "../../../../common/common";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export default function ProductDetail({
    detailsData,
    setDetailsData,
    errors,
    setErrors,
    setSkuNo,
    skuNo,
    isDefault,
    setIsDefault,
    setDataLoading
}) {
    const { roles, user } = useSelector(state => state.users);
    const isUser = roles.find((a) => a.id === user?.role_id);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');
    const [categoryData, setCategoryData] = useState([]);
    const [categoryPage, setCategoryPage] = useState(1);
    const [isCategoryAvailable, setIsCategoryAvailable] = useState(true);
    const [categoryLoading, setCategoryLoading] = useState(false);
    const [subCategoryData, setSubCategoryData] = useState([]);
    const [subCategoryPage, setSubCategoryPage] = useState(1);
    const [isSubCategoryAvailable, setIsSubCategoryAvailable] = useState(true);
    const [subCategoryLoading, setSubCategoryLoading] = useState(false);
    const [manufacturerData, setManufacturerData] = useState([]);
    const [manufacturerPage, setManufacturerPage] = useState(1);
    const [isManufacturerAvailable, setIsManufacturerAvailable] = useState(true);
    const [manufacturerLoading, setManufacturerLoading] = useState(false);
    const [vendorData, setVendorData] = useState([]);
    const [vendorPage, setVendorPage] = useState(1);
    const [isVendorAvailable, setIsVendorAvailable] = useState(true);
    const [vendorLoading, setVendorLoading] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedPage, setSelectedPage] = useState(null);
    const [productProvider, setProductProvider] = useState(null);
    const [productOpen, setProductOpen] = useState(false);

    const getSubCategoryData = async (categoryid, pageNo) => {
        try {
            setSubCategoryLoading(true);
            const response = await apiRequest('get', `/category/list?parentId=${categoryid}&pageNo=${pageNo}&pageSize=100&type=subCategory`);
            const { data } = response.data;
            if (data?.length > 0) {
                setIsSubCategoryAvailable(true);
                let array = [];
                const existingData = subCategoryData?.find((a) => a.parentid === categoryid);
                if (existingData) {
                    array = [...subCategoryData, ...data];
                } else {
                    array = [...data];
                }
                const uniqueArray = [
                    ...new Set(
                        array.map((item) => JSON.stringify(item)),
                    ),
                ].map((item) => JSON.parse(item));
                setSubCategoryData(uniqueArray);
                setSubCategoryLoading(false);
            } else {
                setIsSubCategoryAvailable(false);
                setSubCategoryLoading(false);
            }
        } catch (error) {
            setSubCategoryLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const getCategoryData = async (pageNo, searchText) => {
        try {
            setCategoryLoading(true);
            const response = await apiRequest('get', `/category/list?pageNo=${pageNo}&pageSize=100&type=category&${searchText ? `searchText=${searchText}` : ''}`);
            const { data } = response.data;
            if (data?.length > 0) {
                setIsCategoryAvailable(true);
                const array = [...categoryData, ...data];
                const uniqueArray = [
                    ...new Set(
                        array.map((item) => JSON.stringify(item)),
                    ),
                ].map((item) => JSON.parse(item));
                setCategoryData(uniqueArray);
                setCategoryLoading(false);
            } else {
                setIsCategoryAvailable(false);
                setCategoryLoading(false);
            }
        } catch (error) {
            setCategoryLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const getManufacturerData = async (pageNo, searchText) => {
        try {
            setManufacturerLoading(true);
            const response = await apiRequest('get', `/product-provider?type=manufacturer&pageNo=${pageNo}&pageSize=100&${searchText ? `searchText=${searchText}` : ''}`);
            const { data } = response.data;
            if (data?.length > 0) {
                setIsManufacturerAvailable(true);
                const array = [...manufacturerData, ...data];
                const uniqueArray = [
                    ...new Set(
                        array.map((item) => JSON.stringify(item)),
                    ),
                ].map((item) => JSON.parse(item));
                setManufacturerData(uniqueArray);
                setManufacturerLoading(false);
            } else {
                setIsManufacturerAvailable(false);
                setManufacturerLoading(false);
            }
        } catch (error) {
            setManufacturerLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const getVendorData = async (pageNo, searchText) => {
        try {
            setVendorLoading(true);
            const response = await apiRequest('get', `/product-provider?type=vender&pageNo=${pageNo}&pageSize=100&${searchText ? `searchText=${searchText}` : ''}`);
            const { data } = response.data;
            if (data?.length > 0) {
                setIsVendorAvailable(true);
                const array = [...vendorData, ...data];
                const uniqueArray = [
                    ...new Set(
                        array.map((item) => JSON.stringify(item)),
                    ),
                ].map((item) => JSON.parse(item));
                setVendorData(uniqueArray);
                setVendorLoading(false);
            } else {
                setIsVendorAvailable(false);
                setVendorLoading(false);
            }
        } catch (error) {
            setVendorLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    useEffect(() => {
        if (detailsData?.categoryid) {
            getCategoryData(1, detailsData?.categoryName);
            getSubCategoryData(detailsData?.categoryid, subCategoryPage);
        }
    }, [detailsData?.categoryid]);

    useEffect(() => {
        if (!id) {
            getCategoryData(categoryPage);
        }
        getManufacturerData(manufacturerPage);
        getVendorData(vendorPage);
    }, []);

    const loadNextCategory = async (event) => {
        const listBoxNode = event.currentTarget;
        const numberOfPages = categoryPage + 1;
        const position = listBoxNode.scrollTop + listBoxNode.clientHeight;
        if (listBoxNode.scrollHeight - position <= 1 && isCategoryAvailable) {
            setCategoryPage(numberOfPages);
            await getCategoryData(numberOfPages);
        }
    };

    const loadNextSubCategory = async (event) => {
        const listBoxNode = event.currentTarget;
        const numberOfPages = subCategoryPage + 1;
        const position = listBoxNode.scrollTop + listBoxNode.clientHeight;
        if (listBoxNode.scrollHeight - position <= 1 && isSubCategoryAvailable) {
            setSubCategoryPage(numberOfPages);
            await getSubCategoryData(detailsData?.categoryid, numberOfPages);
        }
    };

    const loadNextManufacturer = async (event) => {
        const listBoxNode = event.currentTarget;
        const numberOfPages = manufacturerPage + 1;
        const position = listBoxNode.scrollTop + listBoxNode.clientHeight;
        if (listBoxNode.scrollHeight - position <= 1 && isManufacturerAvailable) {
            setManufacturerPage(numberOfPages);
            await getManufacturerData(numberOfPages);
        }
    };

    const loadNextVendor = async (event) => {
        const listBoxNode = event.currentTarget;
        const numberOfPages = vendorPage + 1;
        const position = listBoxNode.scrollTop + listBoxNode.clientHeight;
        if (listBoxNode.scrollHeight - position <= 1 && isVendorAvailable) {
            setVendorPage(numberOfPages);
            await getVendorData(numberOfPages);
        }
    };

    return (
        <Grid container spacing={2} style={{ marginTop: 1 }}>
            <CreateDialog
                dialogOpen={dialogOpen}
                setDialogOpen={setDialogOpen}
                selectedPage={selectedPage}
                categoryId={detailsData?.categoryid}
                onGridReady={() => {
                    if (Number(selectedPage) === 0) {
                        getCategoryData(1);
                    } else if (detailsData?.categoryid && Number(selectedPage) === 1) {
                        getSubCategoryData(detailsData?.categoryid, 1);
                    }
                }}
            />
            <ProductProvider
                dialogOpen={productOpen}
                setDialogOpen={setProductOpen}
                productProvider={productProvider}
                onGridReady={() => {
                    if (productProvider === 'manufacturer') {
                        getManufacturerData(manufacturerPage);
                    } else if (productProvider === 'vender') {
                        getVendorData(vendorPage);
                    }
                }}
            />
            {(['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && !detailsData?.is_customer_product) && (
                <>
                    <Grid item xs={12} sm={6} md={3} lg={3}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isDefault}
                                        onClick={(e) => {
                                            setIsDefault(e.target.checked)
                                        }}
                                    />}
                                label="Unspecified Product"
                            />
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={3}>
                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                            <FormControl size="small" fullWidth variant="outlined">
                                <InputLabel htmlFor="standard-adornment-password">Sku No *</InputLabel>
                                <OutlinedInput
                                    label="Sku No *"
                                    id="standard-adornment-password"
                                    type='number'
                                    value={skuNo || ''}
                                    onChange={(e) => {
                                        const newErrors = errors;
                                        if (e.target.value) {
                                            newErrors.skuNo = '';
                                        } else {
                                            newErrors.skuNo = 'Please enter a sku No';
                                        }
                                        setErrors(newErrors);
                                        setSkuNo(e.target.value);
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.keyCode === 38 || event.keyCode === 40) {
                                            event.preventDefault();
                                        }
                                    }}
                                />
                            </FormControl>
                        </Box>
                        <Typography variant='body2' style={{ color: 'red' }}>{errors.skuNo}</Typography>
                    </Grid>
                    <Grid item md={6} lg={6} />
                </>
            )}
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                    <Autocomplete
                        value={categoryData.find((c) => c.category_id === detailsData?.categoryid) || null}
                        id="combo-box-demo"
                        size="small"
                        fullWidth
                        options={categoryData}
                        getOptionLabel={(option) => option?.name}
                        ListboxProps={{
                            onScroll: (event) => loadNextCategory(event),
                        }}
                        onChange={(event, newValue) => {
                            const newErrors = errors;
                            if (newValue?.category_id) {
                                newErrors.category = '';
                            } else {
                                setSubCategoryData([]);
                                newErrors.category = 'Please select category';
                            }
                            setErrors(newErrors);
                            setSubCategoryPage(1);
                            setCategoryPage(1);
                            setDetailsData((prevData) => ({
                                ...prevData,
                                categoryid: newValue?.category_id || null,
                            }));
                        }}
                        onInputChange={(e) => {
                            if (e) {
                                if (e?.target?.value?.length >= 1) {
                                    setCategoryData([]);
                                    setCategoryPage(1);
                                    setSubCategoryPage(1);
                                    getCategoryData(1, e?.target?.value);
                                }
                            }
                        }}
                        renderInput={(params) =>
                            <TextField
                                fullWidth
                                {...params}
                                label="Category *"
                                name="Category *"
                                variant="outlined"
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {categoryLoading ? <CircularProgress color="primary" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />}
                    />
                    {['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && (
                        <Tooltip title="Add Category" onClick={() => {
                            setDialogOpen(true);
                            setSelectedPage('0');
                        }}>
                            <IconButton>
                                <Add />
                            </IconButton>
                        </Tooltip>
                    )}
                </Box>
                <Typography variant='body2' style={{ color: 'red' }}>{errors.category}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                    <Autocomplete
                        value={subCategoryData.find((c) => c.category_id === detailsData?.subCategoryid) || null}
                        id="combo-box-demo"
                        size="small"
                        fullWidth
                        options={subCategoryData}
                        getOptionLabel={(option) => option?.name}
                        ListboxProps={{
                            onScroll: (event) => loadNextSubCategory(event),
                        }}
                        onChange={async (event, newValue) => {
                            const newErrors = errors;
                            if (newValue?.category_id) {
                                newErrors.subCategory = '';
                            } else {
                                newErrors.subCategory = 'Please select subCategory';
                            }
                            setErrors(newErrors);
                            setDetailsData((prevData) => ({
                                ...prevData,
                                subCategoryid: newValue?.category_id || null,
                            }));
                            if (newValue?.category_id && detailsData?.categoryid) {
                                setDataLoading(true);
                                try {
                                    const response = await apiRequest('get', `/product/product-sku/${detailsData?.categoryid}/${newValue?.category_id}`);
                                    if (response?.data) {
                                        setSkuNo(response?.data?.data?.numaric_sku);
                                        setDataLoading(false);
                                    }
                                } catch (error) {
                                    setDataLoading(false);
                                    showNotification(error?.response?.data.error || error.message, 'error');
                                }
                            }
                        }}
                        renderInput={(params) =>
                            <TextField
                                fullWidth
                                {...params}
                                label="Subcategory *"
                                name="Subcategory *"
                                variant="outlined"
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {subCategoryLoading ? <CircularProgress color="primary" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />}
                    />
                    {['mvedasMasterAdmin', 'mvedasAdmin'].includes(isUser?.code) && (
                        <Tooltip title="Add SubCategory" onClick={() => {
                            setDialogOpen(true);
                            setSelectedPage('1');
                        }}>
                            <IconButton disabled={!detailsData?.categoryid}>
                                <Add />
                            </IconButton>
                        </Tooltip>)}
                </Box>
                <Typography variant='body2' style={{ color: 'red' }}>{errors.subCategory}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                    <Autocomplete
                        value={manufacturerData.find((c) => c.product_provider_id === detailsData?.manufacturerid) || null}
                        id="combo-box-demo"
                        size="small"
                        fullWidth
                        disabled={isDefault}
                        options={manufacturerData}
                        getOptionLabel={(option) => option?.name}
                        ListboxProps={{
                            onScroll: (event) => loadNextManufacturer(event),
                        }}
                        onChange={(event, newValue) => {
                            const newErrors = errors;
                            if (newValue?.product_provider_id) {
                                newErrors.manufacturer = '';
                            } else {
                                newErrors.manufacturer = 'Please select manufacturer';
                            }
                            setErrors(newErrors);
                            setDetailsData((prevData) => ({
                                ...prevData,
                                manufacturerid: newValue?.product_provider_id || null,
                            }));
                        }}
                        onInputChange={(e) => {
                            if (e) {
                                if (e?.target?.value?.length >= 1) {
                                    setManufacturerData([]);
                                    setManufacturerPage(1);
                                    getManufacturerData(1, e?.target?.value);
                                }
                            }
                        }}
                        renderInput={(params) =>
                            <TextField
                                fullWidth
                                {...params}
                                label={skuNo === 0 ? "Manufacturer" : "Manufacturer *"}
                                name={skuNo === 0 ? "Manufacturer" : "Manufacturer *"}
                                variant="outlined"
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {manufacturerLoading ? <CircularProgress color="primary" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />}
                    />
                    <Tooltip title="Add Manufacturer" onClick={() => {
                        setProductOpen(true);
                        setProductProvider('manufacturer');
                    }}>
                        <IconButton>
                            <Add />
                        </IconButton>
                    </Tooltip>
                </Box>
                <Typography variant='body2' style={{ color: 'red' }}>{errors.manufacturer}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <FormControl size="small" fullWidth variant="outlined">
                    <InputLabel htmlFor="standard-adornment-password">{skuNo === 0 ? "Model Name" : "Model Name *"}</InputLabel>
                    <OutlinedInput
                        label={skuNo === 0 ? "Model Name" : "Model Name *"}
                        id="standard-adornment-password"
                        type='text'
                        disabled={isDefault}
                        value={detailsData?.modelName || ''}
                        onChange={(e) => {
                            const newErrors = errors;
                            if (e.target.value) {
                                newErrors.model = '';
                            } else {
                                newErrors.model = 'Please enter a model';
                            }
                            setErrors(newErrors);
                            setDetailsData((prevData) => ({
                                ...prevData,
                                modelName: e.target.value,
                            }));
                        }}
                    />
                    <Typography variant='body2' style={{ color: 'red' }}>{errors.model}</Typography>
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                    <Autocomplete
                        value={vendorData.find((c) => c.product_provider_id === detailsData?.vendorid) || null}
                        id="combo-box-demo"
                        size="small"
                        fullWidth
                        options={vendorData}
                        getOptionLabel={(option) => option?.name}
                        ListboxProps={{
                            onScroll: (event) => loadNextVendor(event),
                        }}
                        onChange={(event, newValue) => {
                            setDetailsData((prevData) => ({
                                ...prevData,
                                vendorid: newValue?.product_provider_id || null,
                            }));
                        }}
                        onInputChange={(e) => {
                            if (e) {
                                if (e?.target?.value?.length >= 1) {
                                    setVendorData([]);
                                    setVendorPage(1);
                                    getVendorData(1, e?.target?.value);
                                }
                            }
                        }}
                        renderInput={(params) =>
                            <TextField
                                fullWidth
                                {...params}
                                label="Vendor"
                                name="Vendor"
                                variant="outlined"
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {vendorLoading ? <CircularProgress color="primary" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />}
                    />
                    <Tooltip title="Add Vendor" onClick={() => {
                        setProductOpen(true);
                        setProductProvider('vender');
                    }}>
                        <IconButton>
                            <Add />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <Autocomplete
                    value={ProductType.find((c) => c.value === detailsData?.productType) || null}
                    id="combo-box-demo"
                    size="small"
                    fullWidth
                    options={ProductType}
                    getOptionLabel={(option) => option?.name}
                    onChange={(event, newValue) => {
                        setDetailsData((prevData) => ({
                            ...prevData,
                            productType: newValue?.value || ProductType[0]?.value,
                        }));
                    }}
                    renderInput={(params) => <TextField fullWidth {...params} label="Product Type *" name="Product Type *" variant="outlined" />}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                    <FormControl size="small" fullWidth variant="outlined">
                        <InputLabel htmlFor="standard-adornment-password">{skuNo === 0 ? "Price" : "Price *"}</InputLabel>
                        <OutlinedInput
                            label={skuNo === 0 ? "Price" : "Price *"}
                            id="standard-adornment-password"
                            type='number'
                            value={detailsData?.price}
                            startAdornment={<InputAdornment position="start">₹</InputAdornment>}
                            onChange={(e) => {
                                const newErrors = errors;
                                if (e.target.value) {
                                    newErrors.price = '';
                                } else {
                                    newErrors.price = 'Please enter a price';
                                }
                                setErrors(newErrors);
                                setDetailsData((prevData) => ({
                                    ...prevData,
                                    price: e.target?.value || null
                                }));
                            }}
                            onKeyDown={(event) => {
                                if (event.keyCode === 38 || event.keyCode === 40) {
                                    event.preventDefault();
                                }
                            }}
                        />
                    </FormControl>
                </Box>
                <Typography variant='body2' style={{ color: 'red' }}>{errors.price}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <Autocomplete
                    value={PriceType.find((c) => c.value === detailsData?.priceType) || null}
                    id="combo-box-demo"
                    size="small"
                    fullWidth
                    options={PriceType.slice(0, 2)}
                    getOptionLabel={(option) => option?.name}
                    onChange={(event, newValue) => {
                        setDetailsData((prevData) => ({
                            ...prevData,
                            priceType: newValue?.value || null,
                        }));
                    }}
                    renderInput={(params) => <TextField fullWidth {...params} label="Price Type *" name="Price Type *" variant="outlined" />}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <Autocomplete
                    value={ProductStatus.find((c) => c.value === detailsData?.status) || null}
                    id="combo-box-demo"
                    size="small"
                    fullWidth
                    options={ProductStatus}
                    getOptionLabel={(option) => option?.name}
                    onChange={(event, newValue) => {
                        setDetailsData((prevData) => ({
                            ...prevData,
                            status: newValue?.value || null,
                        }));
                    }}
                    renderInput={(params) => <TextField fullWidth {...params} label="Status *" name="Status *" variant="outlined" />}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <FormControl size="small" fullWidth variant="outlined">
                    <InputLabel htmlFor="standard-adornment-password">Catalog #</InputLabel>
                    <OutlinedInput
                        label="Catalog #"
                        id="standard-adornment-password"
                        type='text'
                        value={detailsData?.catalog || ''}
                        onChange={(e) => {
                            setDetailsData((prevData) => ({
                                ...prevData,
                                catalog: e.target?.value
                            }));
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <Autocomplete
                    value={Responsibility.find((c) => c.value === detailsData?.furnishResponsibility) || null}
                    id="combo-box-demo"
                    size="small"
                    fullWidth
                    options={Responsibility}
                    getOptionLabel={(option) => option?.name}
                    onChange={(event, newValue) => {
                        setDetailsData((prevData) => ({
                            ...prevData,
                            furnishResponsibility: newValue?.value || null,
                        }));
                    }}
                    renderInput={(params) => <TextField fullWidth {...params} label="Furnish Responsibility" name="Furnish Responsibility" variant="outlined" />}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <Autocomplete
                    value={Responsibility.find((c) => c.value === detailsData?.installResponsibility) || null}
                    id="combo-box-demo"
                    size="small"
                    fullWidth
                    options={Responsibility}
                    getOptionLabel={(option) => option?.name}
                    onChange={(event, newValue) => {
                        setDetailsData((prevData) => ({
                            ...prevData,
                            installResponsibility: newValue?.value || null,
                        }));
                    }}
                    renderInput={(params) => <TextField fullWidth {...params} label="Install Responsibility" name="Install Responsibility" variant="outlined" />}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <Autocomplete
                    value={ArchitecturalCode.find((c) => c.value === detailsData?.architecturalCode) || null}
                    id="combo-box-demo"
                    size="small"
                    fullWidth
                    options={ArchitecturalCode}
                    getOptionLabel={(option) => option?.name}
                    getOptionDisabled={(option) => ['8', '9', '10'].includes(option.value)}
                    onChange={(event, newValue) => {
                        setDetailsData((prevData) => ({
                            ...prevData,
                            architecturalCode: newValue?.value || null,
                        }));
                    }}
                    renderInput={(params) => <TextField fullWidth {...params} label="Architectural Code" name="Architectural Code" variant="outlined" />}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <FormControl size="small" fullWidth variant="outlined">
                    <InputLabel htmlFor="standard-adornment-password">Lead Time</InputLabel>
                    <OutlinedInput
                        label="Lead Time"
                        id="standard-adornment-password"
                        type='number'
                        endAdornment={<InputAdornment position="start">Days</InputAdornment>}
                        value={detailsData?.leadtime || ''}
                        onChange={(e) => {
                            setDetailsData((prevData) => ({
                                ...prevData,
                                leadtime: e.target?.value
                            }));
                        }}
                        onKeyDown={(event) => {
                            if (event.keyCode === 38 || event.keyCode === 40) {
                                event.preventDefault();
                            }
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <Autocomplete
                    value={LifeExpectancy.find((c) => c.value === detailsData?.lifeExpectancy) || null}
                    id="combo-box-demo"
                    size="small"
                    fullWidth
                    options={LifeExpectancy}
                    getOptionLabel={(option) => option?.name}
                    onChange={(event, newValue) => {
                        setDetailsData((prevData) => ({
                            ...prevData,
                            lifeExpectancy: newValue?.value || null,
                        }));
                    }}
                    renderInput={(params) => <TextField fullWidth {...params} label="Life Expectancy" name="Life Expectancy" variant="outlined" />}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <Autocomplete
                    value={Discontinues.find((c) => c.value === detailsData?.isDiscontinued) || null}
                    id="combo-box-demo"
                    size="small"
                    fullWidth
                    options={Discontinues}
                    getOptionLabel={(option) => option?.name}
                    onChange={(event, newValue) => {
                        setDetailsData((prevData) => ({
                            ...prevData,
                            isDiscontinued: newValue?.value || Discontinues?.[1].value,
                        }));
                    }}
                    renderInput={(params) => <TextField fullWidth {...params} label="Is This Product Discontinued" name="discontinued" variant="outlined" />}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={detailsData?.international}
                                onClick={(e) => {
                                    setDetailsData((prevData) => ({
                                        ...prevData,
                                        international: e.target.checked
                                    }));
                                }}
                            />}
                        label="International"
                    />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={detailsData?.architecturallySignificant}
                                onClick={(e) => {
                                    setDetailsData((prevData) => ({
                                        ...prevData,
                                        architecturallySignificant: e.target.checked
                                    }));
                                }}
                            />}
                        label="Architecturally Significant"
                    />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={detailsData?.spatiallySignificant}
                                onClick={(e) => {
                                    setDetailsData((prevData) => ({
                                        ...prevData,
                                        spatiallySignificant: e.target.checked
                                    }));
                                }}
                            />}
                        label="Spatially Significant"
                    />
                </FormGroup>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
                <FormControl size="small" fullWidth variant="outlined">
                    <InputLabel htmlFor="standard-adornment-password">Long Description</InputLabel>
                    <OutlinedInput
                        label="Long Description"
                        id="standard-adornment-password"
                        type='text'
                        multiline
                        minRows={4}
                        value={detailsData?.description || ''}
                        onChange={(e) => {
                            setDetailsData((prevData) => ({
                                ...prevData,
                                description: e.target.value,
                            }));
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <FormControl size="small" fullWidth variant="outlined">
                    <InputLabel htmlFor="standard-adornment-password">Notes</InputLabel>
                    <OutlinedInput
                        label="Notes"
                        id="standard-adornment-password"
                        type='text'
                        multiline
                        minRows={4}
                        value={detailsData?.notes || ''}
                        onChange={(e) => {
                            if (e.target.value?.length > 300) {
                                showNotification('The notes should be maximum 300 characters long', 'error');
                            } else {
                                setDetailsData((prevData) => ({
                                    ...prevData,
                                    notes: e.target.value,
                                }));
                            }
                        }}
                    />
                </FormControl>
            </Grid>
        </Grid>
    )
}